import React from "react";
import { Dialog, DialogContent } from "../misc/Dialog";
import Post from "./Post";
import { SocketProvider } from "../../context/SocketContext";

interface PostPreviewProps {
    isOpen: boolean;
    onClose: () => void;
    postId: string;
}

const PostPreview: React.FC<PostPreviewProps> = ({
    isOpen,
    onClose,
    postId,
}) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-6xl w-full h-[90vh] overflow-hidden p-0">
                <div className="h-full overflow-y-auto">
                    <SocketProvider>
                        <Post postId={postId} isDialog={true} onClose={onClose} />
                    </SocketProvider>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default PostPreview;